interface DateOptions {
  month: 'long';
  day: 'numeric';
  year: 'numeric';
}

export const formatDate = (value: string): string => {
  const dateOptions: DateOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };
  return new Date(value).toLocaleDateString('en-US', dateOptions);
};

export default formatDate;
